<template>
  <div class="card w-full">
    <div class="card-body p-0 py-4">
        <div class="d-flex justify-content-between align-items-center px-4 pb-3">
          <h2 class="m-0">New Contracts</h2>
          <div class="d-flex" style="position: relative;">
            
            <div class="button-text d-flex justify-content-center align-items-center">
              <a @click="refreshAll()" style="" class="btn-theme" >Refresh</a>
              <a @click="loadMore" style="" class="btn-theme" >Load more</a>
            </div>
            <!-- <vs-select :placeholder="''" v-model="source">
              <vs-option v-for="(sourceInfo, sourceKey) in sources" :key="'dex-'+sourceKey" :label="sourceKey" :value="sourceKey">
                {{sourceKey}}
              </vs-option>
            </vs-select> -->
            <!-- <input @keyup="onSearch" id="contract-address-search" type="text"  class="form-control" placeholder="Search..."> -->
          </div>
        </div>
        <div class="table-responsive" v-for="(sourceInfo, sourceKey) in sources" :key="'table-'+sourceKey">
          <div class="table m-0 align-items-center border0 w-100">
              <h2 class="ml-2" style="margin-left: 30px; margin-top: 20px;">{{ sourceKey }}</h2>
              <div v-for="(contract, index) in contracts[sourceKey]" :key="'initial' + contract.get('address') + index"
                style="border-bottom: 1px solid gray; cursor: pointer"
                @click="onOpenContract(sourceKey, contract)"
              >
                <div class="d-flex justify-between">
                  <td style="width: 30%!important" :style="contract.get('owner') && hasD[contract.get('owner').toLowerCase()] ? 'color: red' : ''">
                    <b style="margin-left: 20px;">({{ contract.get('network') ? contract.get('network').toUpperCase() : 'Unknown' }}) - </b> <b style="margin-left: 10px;;">{{ contract.get('name') }} / {{ contract.get('symbol') }}</b> 
                  </td>
                  <td>
                    {{formatTime(contract.get('createdAt'))}} <b>({{timeSince(contract.get('createdAt'))}} ago) </b>
                    {{contract.get('owner') && hasD[contract.get('owner').toLowerCase()]}}
                  </td>
                  <td>
                    <div class="button-text d-flex justify-content-center align-items-center">
                      <a @click.stop="openHP(contract)" style="" class="btn-theme" >HP</a>
                      <a @click.stop="openCa(contract)" style="" class="btn-theme" >CA</a>
                      <a @click.stop="openOwner(contract)" style="" class="btn-theme" >TS</a>
                      <a @click.stop="openChart(contract)" style="" class="btn-theme" >Chart</a>
                      <a @click.stop="refreshRevenue(contract)" style="" class="btn-theme" >
                        {{isRefreshing[contract.get('address').toLowerCase()] ? '...' : (bbs[contract.get('address').toLowerCase()] ? (bbs[contract.get('address').toLowerCase()]) : 'Refresh')}}
                      </a>
                    </div>
                  </td>
                </div>
              </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Utils from '@/helpers/Utils';
import Vue from 'vue';
import Web3 from '@/helpers/Web3';

// eslint-disable-next-line no-unused-vars
import Whitelists from '@/whitelists.js';
// eslint-disable-next-line no-unused-vars
import DefaultParse from "@/helpers/Parse";
import Parse from "@/helpers/Parse";
import Zerion from "@/helpers/Zerion";

const PAGE_SIZE = 15;
export default {
  name: "List",
  props: [],
  components: {
  },
  data() {
    return {
      bbs: {},
      isRefreshing: {},
      parse: {},
      sources: {
        Default: {
          id: 'insidor',
          url: 'https://unixswap.net/insidor',
          password: 'sniper'
        },
        F: {
          id: 'tokenor',
          url: 'https://unixswap.net/tokenor',
          password: 'sniper'
        },
        S: {
          id: 'insidor',
          url: 'https://ksniper.com/insidor',
          password: 'sniper'
        },
        SO: {
          id: 'tokenor',
          url: 'https://unixswap.net/saturnor',
          password: 'sniper'
        },
        H: {
          id: 'insidor',
          url: 'https://fastape.me/api/insidor',
          password: 'sniper'
        },
        // BLACK: {
        //   id: 'insidor',
        //   url: 'https://api.blacksniper.org/insidor',
        //   password: 'sniper'
        // }
      },
      source: 'Default',
      // contracts: [],
      contracts: {
        Default: [],
        F: [],
        S: [],
        SO: [],
        H: {},
        // BLACK: []
      },
      offset: 0,
      pageSize: PAGE_SIZE,
      query: '',
      timer: null,
      hasD: {}
    };
  },
  beforeDestroy() {
  },
  computed: {
    ...mapGetters({
    })
  },
  watch: {
    // async source() {
    //   await this.refreshAll();
    // }
  },
  async mounted() {
    // this.fetchRevEther('0xca88e67878dfbeb73c73343f90a3f86220d4049e');
    // return;
    // await this.fetchRevEther('0xec199bf307eb74ac216bacccac927811cdb54a48');
    // return;
    // eslint-disable-next-line no-unreachable
    await this.login('Default');
    await this.fetchRevs();
    // for (let sourceKey of Object.keys(this.sources)) {
    //   this.parse[sourceKey] = new PARSE(this.sources[sourceKey].id, this.sources[sourceKey].url);
    //   const Parse = this.parse[sourceKey];
    //   // try {
    //   //   await Parse.getUserClass().logOut();
    //   // } catch (e) {
    //   //   console.log(e);
    //   // }
    //   // const items = { ...localStorage };
    //   // for (let lsKey of Object.keys(items)) {
    //   //   if (lsKey.substring(0,5) == 'Parse') {
    //   //     localStorage.removeItem(lsKey);
    //   //   }
    //   // }
    //   const address = '0x0000000000000000000000000000';
    //   Parse.initWithParam(this.sources[this.source].id, this.sources[this.source].url);
    //   const User = Parse.getUserClass();
    //   const query = Parse.getQuery(User);
    //   query.equalTo('address', address);
    //   let user = await query.find();
    //   if (user.length == 0) {
    //     user = new User({
    //       address: address.toLowerCase(),
    //       username: address.toLowerCase(),
    //       password: this.sources[this.source].password
    //     });
    //     await user.save();
    //   }

    //   await Parse.getUserClass().logIn(address, this.sources[this.source].password);
    //   this.parse[sourceKey] = Parse;
    // }
    await this.refreshAll();
  },
  methods: {
    ...mapActions({
    }),
    async login(source) {
      try {
        await Parse.getUserClass().logOut();
      } catch (e) {
        console.log(e);
      }
      const items = { ...localStorage };
      for (let lsKey of Object.keys(items)) {
        if (lsKey.substring(0,5) == 'Parse') {
          localStorage.removeItem(lsKey);
        }
      }
      const address = '0x0000000000000000000000000000';
      Parse.initWithParam(this.sources[source].id, this.sources[source].url);
      const User = Parse.getUserClass();
      const query = Parse.getQuery(User);
      query.equalTo('address', address);
      let user = await query.find();
      if (user.length == 0) {
        user = new User({
          address: address.toLowerCase(),
          username: address.toLowerCase(),
          password: this.sources[source].password
        });
        await user.save();
      }

      await Parse.getUserClass().logIn(address, this.sources[source].password);

    },
    async fetchRevs() {  
      await this.login('Default');
      const Revenue = DefaultParse.getClass('Revenue');
      const query = DefaultParse.getQuery(Revenue);
      query.descending("createdAt");
      query.limit(500);
      let revObjs = await query.find();
      for (let revObj of revObjs) {
        this.bbs[revObj.get('address').toLowerCase()] = revObj.get('bb');
      }
      
    },
    async refreshRevenue(contract) {
      this.isRefreshing[contract.get('address').toLowerCase()] = true;
      // const Revenue = DefaultParse.getClass('Revenue');
      // const query = DefaultParse.getQuery(Revenue);
      // const address = contract.get('address');
      // query.matches('address', contract.get('address'), 'i');
      // let revObj = await query.find();
      // if (revObj.length == 0) {
      //   revObj = new Revenue({
      //     address: address.toLowerCase(),
      //     bb: 0
      //   });
      //   await revObj.save();
      // } else {
      //   revObj = revObj[0];
      // }
      // console.log(revObj);
      const bb = await this.fetchRevEther(contract.get('address'));
      // revObj.set('bb', bb);
      // revObj.save();
      Vue.set(this.bbs, contract.get('address').toLowerCase(), bb);
      this.isRefreshing[contract.get('address').toLowerCase()] = false;
    },
    formatBalance(num) {
      return Utils.formatBalance(num);
    },
    async fetchRevEther(address) {
      const tokenAddress = address;
      // eslint-disable-next-line no-unused-vars
      const apiKey = '9ICVHQ2S2QW6VP2WED7MVD2BI6BEH17SG6';
      // eslint-disable-next-line no-unused-vars
      const token = Web3.getTokenContract(tokenAddress);
      // eslint-disable-next-line no-unused-vars
      const wethAddress = '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2';
      const dex = Web3.getDexList()[0];
      const factory = Web3.getUniswapV2FactoryContract(dex.address);
      const pairAddress = await factory.methods.getPair(Web3.getWETHAddress(), tokenAddress).call();
      console.log('pair address', pairAddress)

      const url = 'https://unixswap.net/fetch';
      // const url = 'http://localhost:3000/fetch';

      const swaps = [];
      let from = 0;
      // eslint-disable-next-line no-constant-condition
      while(true) {
        const data = await fetch(
          url,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              address: pairAddress,
              from: from
            })
          }
        ).then(res => res.json());

        // console.log(data, data.data.events.length);

        const events = data.data.events;

        const lastTimestamp = events[events.length - 1].timestamp;

        // console.log(events);
        for (let event of events) {
          if (events.length == 100 && event.timestamp <= lastTimestamp) {
            from = event.timestamp;
            break;
          }
          if (event.type != 1 && event.type != 0) {
            continue;
          }

          let eventDisplayType = event.type == 0 ? 'Sell' : 'Buy';

          // if (event.txnData.token0Balance == "0" && event.txnData.token1Balance == "0") {
          //   eventDisplayType = 'Sell';
          // } else {
          //   eventDisplayType = 'Buy';
          // }

          swaps.push({
            ...event,
            eventDisplayType: eventDisplayType,
            data: {
              priceBaseTokenTotal: event.ncTotalAmount
            }
          });
        }
        if (events.length < 100) {
          break;
        }
      }

      if (swaps[swaps.length - 1].eventDisplayType == 'Sell') {
        for (let i = 0; i < swaps.length; i++) {
          if (swaps[i].eventDisplayType == 'Buy') {
            swaps[i].eventDisplayType = 'Sell';
          } else {
            swaps[i].eventDisplayType = 'Buy';
          }
        }
      }
      
      console.log(swaps.length);
      // return;
      
      // const swaps = data.swaps;

      // console.log(swaps);

      let buys = 0;
      let sells = 0;
      let totalGasFee = 0;
      let totalGasFeeFetch = 0;
      let shouldDecrease = false;
      const bbTxs = [];
      const buyTxs = [];
      const sellTxs = [];
      for (let i = 0; i < swaps.length; i++) {
        const swap = swaps[i];
        // console.log(swap);

        const maker = swaps[i].maker.toLowerCase();
        if (Whitelists.whitelists.includes(maker)) {
          if (maker == '0xcAdc081AA196c9E9ac0222258252BA903c0BF9B1'.toLowerCase()) {
            shouldDecrease = true;
          }
          if (!bbTxs.includes(swap.transactionHash)) {
            bbTxs.push(swap.transactionHash);
            totalGasFee += parseFloat(swap.ncGasUsed);
          }
          continue;
        }
        if (swap.eventDisplayType == 'Sell') {
          sells += parseFloat(swap.data.priceBaseTokenTotal);
          
          sellTxs.push({
            amount: parseFloat(swap.data.priceBaseTokenTotal).toFixed(4),
            link: 'https://etherscan.io/tx/' + swap.transactionHash
          })
          if (swaps[i+1].eventDisplayType == 'Sell' && swaps[i+1].transactionHash == swap.transactionHash) {
            i++;
            continue;
          }
        } else if (swap.eventDisplayType == 'Buy') {
          buys += parseFloat(swap.data.priceBaseTokenTotal);
          buyTxs.push({
            amount: parseFloat(swap.data.priceBaseTokenTotal).toFixed(4),
            link: 'https://etherscan.io/tx/' + swap.transactionHash
          })
        }
      }
      if (shouldDecrease) {
        buys -= 0.2;
      }
      buys -= 0.02;
      console.log('Buys total', buys);
      console.log('Sells total', sells);
      console.log('Revenue', buys - sells);

      // const chunkSize = 20;
      // for (let i = 0; i < bbTxs.length; i += chunkSize) {
      //   const chunk = bbTxs.slice(i, i + chunkSize);

      //   const promises = [];
      //   for (let txHash of chunk) {
      //     promises.push(new Promise((resolve) => {
      //       Web3.web3.eth.getTransactionReceipt(txHash).then(tx => {
      //         resolve(tx.gasUsed * tx.effectiveGasPrice);
      //       })
      //     }));
      //   }
      //   const chunkFees = await Promise.all(promises);
      //   chunkFees.map(fee => {
      //     totalGasFeeFetch += fee;
      //   })
      // }

      console.log('Total Gas in eth', (totalGasFee));
      console.log('Total Gas in eth from direct fetch', (totalGasFeeFetch));

      let totalBB = buys - sells - (totalGasFee);
      
      
      console.log('Total BBs: ', totalBB);

      let lastSellAmount = 0;
      // get pair's weth balance
      const weth = Web3.getTokenContract(Web3.getWETHAddress());
      // eslint-disable-next-line no-undef
      const pairWeth = Utils.formatBalance(parseInt(await weth.methods.balanceOf(pairAddress).call()));
      console.log('Pair Weth', pairWeth);
      if (pairWeth < 0.1) {
        let i = 0;
        while(i < swaps.length) {
          if (swaps[i].eventDisplayType == 'Sell') {
            lastSellAmount = parseFloat(swaps[i].data.priceBaseTokenTotal);
            console.log('Dev sell', lastSellAmount);
            sellTxs.shift();
            // if (swaps[i+1] && swaps[i+1].transactionHash == swaps[i].transactionHash) {
            //   const sellAmount = parseFloat(swaps[i+1].data.priceBaseTokenTotal);
            //   console.log('Dev sell To Fee', sellAmount);
            //   lastSellAmount += sellAmount
            //   sellTxs.shift();
            // }
            break;
          }
          i++;
        }
      }
      totalBB += lastSellAmount;

      console.log('Finalzed BBs: ', totalBB);

      console.log('Buy Txs', buyTxs);
      console.log('Sell Txs', sellTxs);
      const bbinfo = parseFloat(totalBB.toFixed(3));
      Vue.set(this.bbs, address.toLowerCase(), bbinfo);
      return bbinfo;

      // const events = await fetch(
      //   `https://api.etherscan.io/api?module=account&action=tokentx&contractaddress=${wethAddress}&address=${pairAddress}&page=1&offset=2000&startblock=0&endblock=99999999&sort=desc&apikey=${apiKey}`
      // ).then(res => res.json())
      // .then(res => res.result);
      // const txCache = {};

      // for (let event of events) {
      //   const txHash = event.transactionHash;
      //   if (!txCache[txHash]) {
      //     // const txDetails = await web3.eth.getTransaction(txHash);
      //     txCache[txHash] = await Web3.web3.eth.getTransactionReceipt(txHash);
      //   }
      //   const tx = txCache[txHash];
      //   let address = tx.from;
      //   if (!addrCache.includes(address)) {
      //     addrCache.push(address);
      //   }
      // }

      

    },
    async fetchRevenue(contract) {
      
      const tokenAddress = contract.get('address');
      const token = Web3.getTokenContract(tokenAddress);

      let addresses = [];

      console.log('Fetching');

      
      const dex = Web3.getDexList()[0];
      const factory = Web3.getUniswapV2FactoryContract(dex.address);
      const pairAddress = await factory.methods.getPair(Web3.getWETHAddress(), contract.get('address')).call();

      // eslint-disable-next-line no-unused-vars
      const whitelists = [
        '0x0f77002B33b7F3473D3329faB2ACB2AB05006f43'.toLowerCase(),
        '0x634847D6b650B9f442b3B582971f859E6e65eB53'.toLowerCase(),
        '0xd152f549545093347a162dce210e7293f1452150'.toLowerCase(),
        '0x1d3970677aa2324E4822b293e500220958d493d0'.toLowerCase(),
        '0xAAb81110a565C083E4a2DBfB1F6cD812612B2fe7'.toLowerCase(),
        '0xd152f549545093347a162dce210e7293f1452150'.toLowerCase(),
        '0x5c20df4b1b0103dec0f72fe76457431d97a38293'.toLowerCase(),
      ];

      // eslint-disable-next-line no-unused-vars
      const excludes = [
        pairAddress.toLowerCase(),
        "0x0000000000000000000000000000000000000000",
        "0x00000000a991c429ee2ec6df19d40fe0c80088b8".toLowerCase(),
        "0x429Cf888dAE41D589D57F6Dc685707beC755fe63".toLowerCase(),
        "0xe89e9baa8886c10b0f390346c5cb57a555e0a742".toLowerCase(),
        contract.get('owner').toLowerCase(),
        contract.get('address').toLowerCase() 
      ]

      let isBanana = false;
      const bbAddr = [];
      if (bbAddr.length == 0)  {
        // eslint-disable-next-line no-unused-vars
        const events = await token.getPastEvents('Transfer',  {
          fromBlock: 0,
          toBlock: 'latest'
        });

        // const events = await token.events.Transfer({
        //   fromBlock: 0,
        //   toBlock: 'latest'
        // });

        // console.log(events);
        
        let addrCache = [];
        
        for (let event of events) {
          const txHash = event.transactionHash;
          // const txDetails = await web3.eth.getTransaction(txHash);
          const tx = await Web3.web3.eth.getTransactionReceipt(txHash);
          let address = tx.from;        
          console.log(address);
          if (!addrCache.includes(address)) {
            addrCache.push(address);
          }
            
          // const from = event.returnValues.from.toLowerCase();
          // const to = event.returnValues.to.toLowerCase();

          // if (!addrCache.includes(from) && !excludes.includes(from)) {
          //   addrCache.push(from);
          // }

          // if (!addrCache.includes(to) && !excludes.includes(to)) {
          //   addrCache.push(to);
          // }

          // if (addrCache.length == 10) break;
          // addrCache = [
          //   '0x58d12c060c56fa2a285cc2fe003ea4bbcdd21a6d'.toLowerCase(),
          //   '0x23263460a3a2444e193f73ca71a6b7831ebe6063'.toLowerCase()
          // ]; break;
        }
        console.log(addrCache);
        
        const chunkSize = 10;
        for (let i = 0; i < addrCache.length; i += chunkSize) {
            const chunk = addrCache.slice(i, i + chunkSize);
            console.log(chunk);
            // let actions = await Zerion.getActionsByType(chunk, ['receive'], 100);            
            // let actions = await Zerion.getAssetActionsWithDisperse(chunk, 'eth', ['receive']);
            let actions = await Zerion.getAssetActions(chunk, 'eth', ['receive']);
            console.log(actions);
            if (actions.payload) {
              actions = actions.payload.actions;
            }
            for (let action of actions) {
              if (addresses.includes(action.address.toLowerCase())) continue;
              // console.log('checking action', action);
              const ethSender = action.content.transfers.incoming[0].sender.toLowerCase()
              if (whitelists.includes(ethSender) || addresses.includes(ethSender)) {
                // console.log(action);
                addresses.push(action.address.toLowerCase());
                // break;
              }
            }
        }
      } else {
        addresses = [];
        this.bbAddr.map(address => {
          if (!addresses.includes(address.toLowerCase())) {
            addresses.push(address.toLowerCase());
          }
        })
        isBanana = true;
      }

      console.log('final', addresses);
      // addresses = [addresses[0]];
      // eslint-disable-next-line no-undef
      let fees = BigInt(0)
      // eslint-disable-next-line no-undef
      let ins = BigInt(0);
      // eslint-disable-next-line no-undef
      let outs = BigInt(0);

      
      const asset = (await Zerion.searchAssets(tokenAddress));
      let assetId;

      if (asset.length == 0) {
        const approveActions = (await Zerion.getActionsByType([addresses[0]], ['approve'], 50)).payload.actions;

        for (let approveAction of approveActions) {
          const fungible = approveAction.content.single_asset.asset.fungible;
          if (fungible.implementations.ethereum.address.toLowerCase() == tokenAddress.toLowerCase()) {
            assetId = fungible.id;
            break;
          }
        }
      } else {
        assetId = asset[0].asset.id;
      }

      console.log('asset id', assetId);
      // const assetId = 'fafbc095-dd01-47c6-84ea-de8220663b1b';
      const chunkSize = 10;
      for (let i = 0; i < addresses.length; i += chunkSize) {
          const chunk = addresses.slice(i, i + chunkSize);
          // for (let address of chunk) {
            // eslint-disable-next-line no-undef
            let localIns = BigInt(0);
            // eslint-disable-next-line no-undef
            let localOuts = BigInt(0);

            let actions = await Zerion.getAssetActions(chunk, assetId, ['trade']);

            // console.log('chunks', chunk);
            // console.log('actions', actions);
            if (actions.payload) {
              actions = actions.payload.actions;
            }

            const trades = actions.filter(action => {
              if (action.transaction.fee) {
                // eslint-disable-next-line no-undef
                fees += BigInt(action.transaction.fee.quantity);
              }
              // console.log(isBanana);
              return action.type.value == 'trade' && (!isBanana || action.label.display_value.text == 'BananaGun');
            });
            trades
            .map(trade => {
              // console.log(trade);
              trade.content.transfers.incoming
              .filter(coming => coming.asset.fungible.asset_code == 'eth')
              .map(coming => {
                // console.log('coming', coming);
                // eslint-disable-next-line no-undef
                localIns += BigInt(coming.quantity);
              })

              trade.content.transfers.outgoing
              .filter(going => going.asset.fungible.asset_code == 'eth')
              .map(going => {
                // console.log('going', going);
                // eslint-disable-next-line no-undef
                localOuts += BigInt(going.quantity);
              })
            })

            ins += localIns;
            outs += localOuts;

            
            console.log('Sell', Utils.formatBalance(parseInt(ins)), 'Buy', Utils.formatBalance(parseInt(outs)));
            // const actions = await Zerion.getTokenActions(tokenAddress, address);
            // console.log(actions);
          // }
      }
      
      // for (let address of addresses) {
      //   // eslint-disable-next-line no-undef
      //   let localIns = BigInt(0);
      //   // eslint-disable-next-line no-undef
      //   let localOuts = BigInt(0);

      //   const actions = await Zerion.getAssetActions([address], assetId);

      //   const trades = actions.filter(action => {
      //     if (action.transaction.fee) {
      //       // eslint-disable-next-line no-undef
      //       fees += BigInt(action.transaction.fee.quantity);
      //     }
      //     return action.type.value == 'trade';
      //   });
      //   trades.map(trade => {
      //     trade.content.transfers.incoming
      //     .filter(coming => coming.asset.fungible.asset_code == 'eth')
      //     .map(coming => {
      //       // console.log('coming', coming);
      //       // eslint-disable-next-line no-undef
      //       localIns += BigInt(coming.quantity);
      //     })

      //     trade.content.transfers.outgoing
      //     .filter(going => going.asset.fungible.asset_code == 'eth')
      //     .map(going => {
      //       // console.log('going', going);
      //       // eslint-disable-next-line no-undef
      //       localOuts += BigInt(going.quantity);
      //     })
      //   })

      //   ins += localIns;
      //   outs += localOuts;

        
      //   console.log(address, 'Sell', Utils.formatBalance(parseInt(ins)), 'Buy', Utils.formatBalance(parseInt(outs)));
      //   // const actions = await Zerion.getTokenActions(tokenAddress, address);
      //   // console.log(actions);
      // }

      console.log('Total Fees: ', Utils.formatBalance(parseInt(fees)));
      console.log('Total Sells: ', Utils.formatBalance(parseInt(ins)));
      console.log('Total Buys: ', Utils.formatBalance(parseInt(outs)));
      const buybacks = parseInt(ins - outs - fees);
      const buybackETH = Utils.formatBalance(buybacks);
      console.log('Total BBs: ', buybackETH);
      return buybacks;
    },
    openHP(contract) {
      let network = contract.get('network');
      if (network == 'main') {
        network = 'ethereum';
      }
      const url = `https://honeypot.is/${network}?address=${contract.get('address')}`;
      window.open(url);
    },
    openCa(contract) {
      const explorers = {
        'main': 'https://etherscan.io/address',
        'base': 'https://basescan.org/address',
      }
      window.open(`${explorers[contract.get('network')]}/${contract.get('address')}`);
    },
    openChart(contract) {
      const explorers = {
        'main': 'https://www.dextools.io/app/ether/pair-explorer',
        'base': 'https://www.dextools.io/app/base/pair-explorer',
      }
      window.open(`${explorers[contract.get('network')]}/${contract.get('address')}`);
    },
    openOwner(contract) {
      let network = contract.get('network');
      if (network == 'main') {
        network = 'eth';
      }
      const url = `https://tokensniffer.com/token/${network}/${contract.get('address')}`;
      window.open(url);
    },
    formatTime(date) {
      const formatter = new Intl.DateTimeFormat('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit' });
      const formattedTime = formatter.format(date);

      // const formattedDate = (new Intl.DateTimeFormat('en-US', { dateStyle: 'short' })).format(date);

      return formattedTime // + ' ' + formattedDate;
    },
    timeSince(date) {
      var seconds = Math.floor((new Date() - date) / 1000);

      var interval = seconds / 31536000;

      if (interval > 1) {
        return Math.floor(interval) + " years";
      }
      interval = seconds / 2592000;
      if (interval > 1) {
        return Math.floor(interval) + " months";
      }
      interval = seconds / 86400;
      if (interval > 1) {
        return Math.floor(interval) + " days";
      }
      interval = seconds / 3600;
      if (interval > 1) {
        return Math.floor(interval) + " hours";
      }
      interval = seconds / 60;
      if (interval > 1) {
        return Math.floor(interval) + " minutes";
      }
      return Math.floor(seconds) + " seconds";
    },
    async refreshD(source) {
      const contracts = this.contracts[source];
      const owners = []
      for (let contract of contracts) {
        if (contract.get('network') == 'main' && contract.get('owner')) {
          const owner = contract.get('owner').toLowerCase();
          if (owner == '0x0000000000000000000000000000000000000000') continue;
          owners.push(owner);
        }
      }
      // console.log('getting gas');
      // Zerion.getBalance(owners[0]).then(gas => {
      //   console.log('gas', gas);
      // });
      const actions = await Zerion.getAssetActions(owners, '0xfb7b4564402e5500db5bb6d63ae671302777c75a'.toLowerCase(), ['trade']);
      // console.log(owners);
      // const actions = await Zerion.getActions(owners);
      console.log(actions);
      for (let action of actions) {
        Vue.set(this.hasD, action.address.toLowerCase(), true);
      }
    },
    async refreshAll(isLoadMore) {
      if (!isLoadMore) {
        this.contracts = {
          Default: [],
          F: [],
          S: [],
          SO: [],
          H: [],
          // BLACK: [],
        };
        this.offset = 0;
      }

      let sourceKeys = Object.keys(this.sources);
      // sourceKeys = ['SO'];

      for (let sourceKey of sourceKeys) {
        this.source = sourceKey;
        await this.login(this.source);


        this.pageSize = PAGE_SIZE;
        await this.refresh();
        this.refreshD(this.source);
      }
    },
    onTG() {
      window.open('https://insidor.org')
    },
    async refresh() {
      let finalQuery;
      const query = Parse.getQuery('Contract');
      query.limit(this.pageSize);
      query.skip(this.offset);
      // if (Web3.isTop()) {
        query.descending("createdAt");
      // } else {
        // query.ascending("createdAt");
      // }

      let filterQuery = null;
      if (this.query && this.query != '') {
        const nameQuery = Parse.getQuery('Contract');
        nameQuery.matches('name', this.query.toLowerCase(), 'i');

        const addressQuery = Parse.getQuery('Contract');
        addressQuery.matches('address', this.query.toLowerCase(), 'i');

        const ownerQuery = Parse.getQuery('Contract');
        ownerQuery.matches('address', this.query.toLowerCase(), 'i');

        filterQuery = Parse.instance().Query.or(nameQuery, addressQuery, ownerQuery);
      }

      if (filterQuery) {
        finalQuery = Parse.instance().Query.and(query, filterQuery);
      } else {
        finalQuery = query;
      }

      const contracts = await finalQuery.find();

      for (let contract of contracts) {
        Vue.set(this.isRefreshing, contract.get('address').toLowerCase(), false);
      }

      // console.log(contracts);
      console.log(this.contracts, this.source);
      this.contracts[this.source].push(...contracts);
    },
    onSearch() {
    },
    async loadMore() {
      this.offset += this.pageSize;
      this.refreshAll(true);
    },
    async onOpenContract() {
    },
    formatAddress(address) {
      return Utils.formatAddress(address);
    },
    formatNumber(num, digits) {
      num = parseFloat(num);
      if (num == 0) return num;
      if (num < 1000) return parseFloat(num.toFixed(5));
      if (!digits) digits = 3;
      const lookup = [
        { value: 1, symbol: "" },
        { value: 1e3, symbol: "k" },
        { value: 1e6, symbol: "M" },
        { value: 1e9, symbol: "G" },
        { value: 1e12, symbol: "T" },
        { value: 1e15, symbol: "P" },
        { value: 1e18, symbol: "E" }
      ];
      const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
      var item = lookup.slice().reverse().find(function(item) {
        return num >= item.value;
      });
      return item ? parseFloat((num / item.value).toFixed(digits)).toString().replace(rx, "$1") + item.symbol : "0";
    },
  },
};
</script>
<style scoped>
.justify-between{
  justify-content: space-between;
}

@media only screen 
    and (max-width: 767px), (min-device-width: 767px) 
    and (max-device-width: 767px)  {

		/* Force table to not be like tables anymore */
		table, thead, tbody, th, td, tr {
			display: block;
		}

		/* Hide table headers (but not display: none;, for accessibility) */
		thead tr {
			position: absolute;
			top: -9999px;
			left: -9999px;
		}

    tr {
      margin: 0 0 1rem 0;
    }
      
    /* tr:nth-child(odd) {
      background: #ccc;
    } */
    
		td {
			/* Behave  like a "row" */
			border: none;
			border-bottom: 1px solid #eee;
			position: relative;
			padding-left: 50%;
      width: 100% !important;
		}

		td:before {
			/* Now like a table header */
			position: absolute;
			/* Top/left values mimic padding */
			top: 50%;
			left: 24px;
			padding-right: 10px;
			white-space: nowrap;
      transform: translate(0px, -50%);
      color: #444444;
		}

		/*
		Label the data
    You could also use a data-* attribute and content for this. That way "bloats" the HTML, this way means you need to keep HTML and CSS in sync. Lea Verou has a clever way to handle with text-shadow.
		*/
    td:nth-of-type(1):before { content: "Name: "; }
		td:nth-of-type(2):before { content: "Balance: "; }
		td:nth-of-type(3):before { content: "TP/SL: "; }
		td:nth-of-type(4):before { content: "Function: "; }

    th {
      display: none;
    }
	}
</style>